'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconBase = require('../icon-base');

var _iconBase2 = _interopRequireDefault(_iconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdpGrip = function (_React$Component) {
  _inherits(AdpGrip, _React$Component);

  function AdpGrip() {
    _classCallCheck(this, AdpGrip);

    return _possibleConstructorReturn(this, (AdpGrip.__proto__ || Object.getPrototypeOf(AdpGrip)).apply(this, arguments));
  }

  _createClass(AdpGrip, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _iconBase2.default,
        this.props,
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M660.48 833.856H363.52c-10.24 0-20.48 10.24-20.48 20.48 0 5.12 0 10.24 5.12 15.36l148.48 153.6c5.12 5.12 10.24 5.12 15.36 5.12s10.24 0 15.36-5.12l148.48-153.6c5.12-5.12 5.12-10.24 5.12-15.36 0-10.24-5.12-20.48-20.48-20.48zm204.8-184.32H158.72c-15.36 0-30.72 10.24-30.72 25.6v46.08c0 15.36 15.36 25.6 30.72 25.6h701.44c15.36 0 30.72-10.24 30.72-25.6v-46.08c5.12-15.36-10.24-25.6-25.6-25.6zm0-384H158.72c-15.36 0-30.72 10.24-30.72 25.6v46.08c0 15.36 15.36 25.6 30.72 25.6h701.44c15.36 0 30.72-10.24 30.72-25.6v-46.08c5.12-15.36-10.24-25.6-25.6-25.6zm0 189.44H158.72c-15.36 0-30.72 10.24-30.72 25.6v46.08c0 15.36 15.36 25.6 30.72 25.6h701.44c15.36 0 30.72-10.24 30.72-25.6v-46.08c5.12-10.24-10.24-25.6-25.6-25.6zm-501.76-276.48h296.96c10.24 0 20.48-10.24 20.48-20.48 0-5.12 0-10.24-5.12-15.36L527.36 9.536c-5.12-5.12-10.24-5.12-15.36-5.12s-10.24 0-15.36 5.12l-148.48 138.24c-5.12 0-5.12 5.12-5.12 10.24 0 10.24 10.24 20.48 20.48 20.48z' })
        )
      );
    }
  }]);

  return AdpGrip;
}(_react2.default.Component);

AdpGrip.defaultProps = {
  viewBox: '0 0 1024 1043.776',
  height: '1em',
  width: '0.9811em'
};

exports.default = AdpGrip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-icons/lib/adp/grip.js
// module id = 607
// module chunks = 0 1 2 3 4 5 6